import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-form-field-input-v2',
    templateUrl: './form-field-input-v2.component.html',
    styleUrls: ['./form-field-input-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldInputV2Component implements OnInit, AfterViewInit {

  @Input() configData: any;
  @Input() frmGroup: UntypedFormGroup;

  constructor() {}
  
  placeHolder = "";
  validationType: string = "";
  disabled: boolean = false;

  @ViewChild('formFieldWrapper',{static: true, read: ElementRef}) formFieldWrapper: ElementRef;

  toggleEnable(bool){
    if(bool)
      this.frmGroup.get(this.configData.name).disable();
    else
      this.frmGroup.get(this.configData.name).enable();    
  }

  ngOnInit() {    
    if (this.configData["disabled"]) {
      this.toggleEnable(true);
    } else {
      this.toggleEnable(false);      
    }

    this.configData.validation.forEach((element) => {
      if (element === "Numeric") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.min(1));
        this.frmGroup
          .get(this.configData.name)
          .setValidators(Validators.pattern(new RegExp("^0*[1-9]\\d*$")));
      } else if (element === "Decimal") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.min(1));
        this.frmGroup
          .get(this.configData.name)
          .setValidators(
            Validators.pattern(
              new RegExp("^\\s*(?=.*[1-9])\\d*(?:\\.\\d{1,99})?\\s*$")
            )
          );
      } else if (element === "DecimalWithMaxlength") {
        this.validationType = element;
        this.frmGroup
          .get(this.configData.name)
          .setValidators(
            Validators.pattern(
              new RegExp(/^\s*(?=.*[1-9])\d{1,3}(?:\.\d{1,2})?\s*$/)
            )
          );
      }
      if (element === "NoSpecialCharacter") {
        this.validationType = element;
        this.frmGroup.get(this.configData.name).setValidators(Validators.pattern(new RegExp('^((?![$<>?%&*#!~`]).)*$')));        
      }
      if (element === "Email") {
        let newexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.validationType = element;
        this.frmGroup.get(this.configData.name)
          .setValidators(Validators.pattern(newexp));
      }
      if (element === "hidden") {
        if (!(this.frmGroup.get(this.configData.name)["hidden"] === false)) {
          this.frmGroup.get(this.configData.name)["hidden"] = true;
        }
      }
    }, this);
  }

    ngAfterViewInit() {
      this.frmGroup.get(this.configData.name).statusChanges.subscribe(x => {
          if(this.frmGroup.get(this.configData.name).value == undefined || this.frmGroup.get(this.configData.name).value == null){
            this.formFieldWrapper.nativeElement.classList.remove("dhl-form-field--is-active",
              "dhl-form-field--set-borderRed", "dhl-form-field--set-border-success", "dhl-form-field--is-filled");
          }
      });
      if(this.frmGroup.get(this.configData.name).value) {
        this.formFieldWrapper.nativeElement.classList.add("dhl-form-field--is-filled");        
      }
    }

  public onBlurSetActive(el, active) {
    el = document.getElementById(el);
    const formField = el.parentNode.parentNode;
    if (active) {
      this.placeHolder = (this.configData && this.configData.placeHolder) ? this.configData.placeHolder: "";
      formField.classList.add("dhl-form-field--is-active");
    } else {
      this.placeHolder = "";
      formField.classList.remove("dhl-form-field--is-active");
      el.value === ""
        ? formField.classList.remove(
            "dhl-form-field--is-filled",
            "dhl-form-field--set-borderRed"
          )
        : formField.classList.add("dhl-form-field--is-filled");
    }
  }

  public validateInput(el, value) {
    
    value = value.trim();
    if (this.configData.type !== "number") {
      this.frmGroup.get(this.configData.name).setValue(value.trim());
    }
    if (
      this.configData["maxLength"] &&
      value.length > parseInt(this.configData["maxLength"])
    ) {
      this.frmGroup.get(this.configData.name).setErrors({
        maxLength: {
          exceedsChar: value.length - parseInt(this.configData["maxLength"]),
        },
      });
    }
    if (
      this.configData["minLength"] &&
      value.length < parseInt(this.configData["minLength"])
    ) {
      this.frmGroup.get(this.configData.name).setErrors({
        minLength: {
          requiredChar: parseInt(this.configData["minLength"]) - value.length,
        },
      });
    }
    if (
      this.configData["textCaps"] &&
      !this.frmGroup.get(this.configData.name).errors
    ) {
      this.frmGroup.get(this.configData.name).setValue(value.toUpperCase());
    }

    el = document.getElementById(el);
    const formField = el.parentNode.parentNode;
    if (this.frmGroup.get(this.configData.name).invalid || this.frmGroup.get(this.configData.name).errors) {
      formField.classList.remove("dhl-form-field--set-border-success");
      formField.classList.add("dhl-form-field--set-border-error");
    } else {
      formField.classList.remove("dhl-form-field--set-border-error");
      formField.classList.remove("dhl-form-field--set-border-success");
      if (this.frmGroup.get(this.configData.name).value && this.frmGroup.get(this.configData.name).value !== "") {
        formField.classList.add("dhl-form-field--set-border-success");
      }
    }
  }

  public clearInput() {
    this.frmGroup.get(this.configData.name).setValue("") ;
  }

  setValueToControl(value){
    if (value != undefined) {
      this.frmGroup.get(this.configData.name).setValue(value);
    }
  }
}
